export const INTERVAL_DURATION = 100; // in milliseconds
export const PROGRESS_INCREMENT_HIGH = 0.01;
export const PROGRESS_INCREMENT_LOW = 0.005;
export const PROGRESS_BASE_PERCENTAGE = 70;
export const MAX_PROGRESS = 100;
